import { parseDetailErrorV2 } from "../api/parseDetailErrorV2";
import parseFieldErrorsV2 from "../api/parseFieldErrorsV2";

/**
 * Injects errors received from API into react-hook-form
 * @typedef {{[key:string]: string}} Error
 */
/**
 * @param {{
 * parsedJson: any,
 * form: import("react-hook-form").UseFormReturn<any>,
 * setMessage: (message: string | null) => void,
 * setCaughtErrors: (errors: Error) => void,
 * setUncaughtErrors: (errors: Error) => void,
 * isSearch: boolean,
 * }} param0
 */
export function resolveApiError({
  parsedJson,
  form,
  setMessage,
  setCaughtErrors,
  setUncaughtErrors,
  isSearch,
}) {
  const { setError, getValues } = form;

  /** @type {string} */
  const message = parseDetailErrorV2({ parsedJson });
  /** @type {Error} */
  const caughtErrors = {};
  /** @type {Error} */
  const uncaughtErrors = {};

  const validNames = getNames(getValues());

  form.clearErrors();

  const errorObject = isSearch
    ? parseFieldErrorsV2({ data: parsedJson })
    : { data: parseFieldErrorsV2({ data: parsedJson }) };
  const errors = resolveApiErrors(errorObject);
  errors.forEach((error) => {
    if (validNames.includes(error.name)) {
      setError(error.name, { message: error.message }, { shouldFocus: true });
      caughtErrors[error.name] = error.message;
    } else {
      uncaughtErrors[error.name] = error.message;
    }
  });

  console.log({ caughtErrors, uncaughtErrors, message });

  setCaughtErrors(caughtErrors);
  setUncaughtErrors(uncaughtErrors);
  setMessage(message);
}

/**
 * @param {any} entity
 * @param {string} currentPath
 * @param {{name: string, message: string}[]} errors
 */
function resolveApiErrors(entity, currentPath = "", errors = []) {
  getEntries(entity).forEach(([key, value]) => {
    if (Array.isArray(value) && typeof value[0] === "string") {
      errors.push({
        name: `${currentPath.length > 0 ? `${currentPath}.${key}` : key}`,
        message: value.join(" "),
      });
    } else if (typeof value === "object" && value !== null) {
      resolveApiErrors(
        entity[key],
        `${currentPath.length > 0 ? `${currentPath}.${key}` : key}`,
        errors,
      );
    }
  });

  return errors;
}

/**
 * @param {any} entity
 * @param {string[]} [path]
 * @param {string[]} [names]
 */
function getNames(entity, path = [], names = []) {
  getEntries(entity).forEach(([key, value]) => {
    if (typeof value === "object" && !key.startsWith?.("_") && value !== null) {
      getNames(value, [...path, key], names);
    } else {
      const fieldPath = [...path, key];
      const name = fieldPath.join(".");
      if (!name?.startsWith("_")) {
        names.push(name);
      }
    }
  });

  return names;
}

/**
 * return entries from any entity (ex: object or array)
 * @param {any} entity
 * @returns {[string, any][]}
 */
function getEntries(entity) {
  /** @type {any[]} */
  let entries = [];
  if (Array.isArray(entity)) {
    entries = entity.map((value, index) => [index, value]);
  } else if (typeof entity === "object" && entity !== null) {
    entries = Object.entries(entity);
  }

  return entries;
}
